import React from "react";
import type { ProductItemTilesToken } from "./productItemTiles.tokens";

export const productItemTilesBaseStyles: Record<string, React.CSSProperties> = {
    section: {
        position: "relative",
        width: "100%",
        display: "grid",
        gap: 16,
        overflow: "hidden",
        boxSizing: "border-box",
    },
    header: {
        position: "relative",
        zIndex: 1,
        display: "grid",
        gap: 8,
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
    },
    eyebrow: {
        margin: 0,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.12em",
        textTransform: "uppercase",
        color: "rgba(17,17,17,0.6)",
    },
    title: {
        margin: 0,
        fontSize: 32,
        lineHeight: 1.05,
        fontWeight: 700,
        color: "#111111",
    },
    description: {
        margin: 0,
        fontSize: 15,
        lineHeight: 1.6,
        color: "rgba(17,17,17,0.72)",
        maxWidth: 780,
    },
    grid: {
        display: "grid",
        gap: 12,
        paddingLeft: 8,
        paddingRight: 8,
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        boxSizing: "border-box",
    },
    itemWrap: {
        minWidth: 0,
    },
};

export const productItemTilesNeutralStyles: Pick<ProductItemTilesToken, "ctaWrap" | "ctaButton"> = {
    ctaWrap: {
        display: "flex",
        justifyContent: "flex-start",
        paddingTop: 2,
    },
    ctaButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 4,
        padding: "12px 18px",
        background: "#111111",
        color: "#ffffff",
        border: "1px solid #222222",
        fontSize: 14,
        fontWeight: 800,
        lineHeight: 1,
        textDecoration: "none",
        boxShadow: "0 10px 20px rgba(0,0,0,0.10)",
    },
};
